import React from "react";
import { PropTypes } from "prop-types";
import { MrbListPage, MrbPageContentHeader } from "mrb/components/layout";
import { MrbTable } from "mrb/components/table";
import { MrbQuerySearchInput } from "mrb/components/input";
import { MrbSelect } from "mrb/components/select";
import { TableNoDataOverlay } from "common/components";
import { defaultTemplate } from "common/hoc";

function UploadedContentTemplate({ uploadedContentViewStore, t }) {
    const {
        gridStore,
        queryUtility,
        producerSelectStore,
        artistSelectStore,
        albumSelectStore,
    } = uploadedContentViewStore;

    return (
        <MrbListPage store={uploadedContentViewStore} t={t}>
            <MrbPageContentHeader classNameOverride="u-mar--bottom--sml">
                <div className="u-display--flex u-display--flex--ai--flex-end u-display--flex--wrap u-gap--base u-mar--bottom--sml">
                    <div className="u-display--flex u-display--flex--column">
                        <label className="c-form__field__label">
                            {t("ADMINISTRATION.UPLOADED_CONTENT.FILTER.PRODUCER_LABEL")}
                        </label>
                        <MrbSelect
                            t={t}
                            closeMenuOnSelect={false}
                            store={producerSelectStore}
                            classNameExtend="c-dropdown--dark c-dropdown--sml-custom"
                        />
                    </div>
                    <div className="u-display--flex u-display--flex--column">
                        <label className="c-form__field__label">
                            {t("ADMINISTRATION.UPLOADED_CONTENT.FILTER.ARTIST_LABEL")}
                        </label>
                        <MrbSelect
                            t={t}
                            closeMenuOnSelect={false}
                            store={artistSelectStore}
                            classNameExtend="c-dropdown--dark c-dropdown--sml-custom"
                        />
                    </div>
                    <div className="u-display--flex u-display--flex--column">
                        <label className="c-form__field__label">
                            {t("ADMINISTRATION.UPLOADED_CONTENT.FILTER.ALBUM_LABEL")}
                        </label>
                        <MrbSelect
                            t={t}
                            closeMenuOnSelect={false}
                            store={albumSelectStore}
                            classNameExtend="c-dropdown--dark c-dropdown--sml-custom"
                        />
                    </div>
                    <MrbQuerySearchInput queryUtility={queryUtility} />
                </div>
            </MrbPageContentHeader>
            <MrbTable
                t={t}
                tableStore={gridStore}
                className="ag-theme-alpine u-mar--bottom--sml"
                emptyStateRender={TableNoDataOverlay}
            />
        </MrbListPage>
    );
}

UploadedContentTemplate.propTypes = {
    uploadedContentViewStore: PropTypes.object.isRequired,
    t: PropTypes.func,
};

export default defaultTemplate(UploadedContentTemplate);
